import React from 'react';
import { createUseStyles } from 'react-jss';
import clsx from 'clsx';

export interface TextProps {
  as?: 'p' | 'span' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  decoration?: 'none' | 'underline' | 'line-through';
  color?: 'default' | 'white' | 'black' | 'red' | 'primary';
  align?: 'left' | 'right' | 'center' | 'justify';
  bold?: boolean;
  fontSize?: 'size1' | 'size2';
  subText?: boolean;
  className?: string;
  uppercase?: boolean;
  lowercase?: boolean;
  capitalized?: boolean;
  itemprop?: string;
  click?: Function

}

const Text: React.FC<TextProps> = ({
  as: As = 'p',
  decoration = 'none',
  color = 'default',
  align = 'unset',
  className,
  bold,
  fontSize,
  subText,
  lowercase,
  uppercase,
  capitalized,
  itemprop,
  click = function () {

  },
  children,
}) => {
  const classes = useStyles();
  return (
    <As
      className={clsx(
        classes.base,
        {
          [classes.bold]: bold,
          [classes.subText]: subText,
          [classes.uppercase]: uppercase,
          [classes.lowercase]: lowercase,
          [classes.capitalized]: capitalized,
          [classes.underlined]: decoration === 'underline',
          [classes.lineThrough]: decoration === 'line-through',
          [classes.white]: color === 'white',
          [classes.primary]: color === 'primary',
          [classes.red]: color === 'red',
          [classes.black]: color === 'black' || color === 'default',
          // [classes[align]]: align !== 'unset',
          [classes.size1]: fontSize === 'size1',
          [classes.size2]: fontSize === 'size2',

        },
        className,
      )}
      onClick={() => click()}
      itemProp={itemprop}

    >
      {children}
    </As>
  );
};

const useStyles = createUseStyles({
  base: {},
  bold: {
    fontWeight: 'bold',
  },
  subText: {
    color: '#b9b9b9',
  },
  uppercase: {
    textTransform: 'uppercase',
  },
  lowercase: {
    textTransform: 'lowercase',
  },
  capitalized: {
    textTransform: 'capitalize',
  },
  underlined: {
    textDecoration: 'underline',
  },
  lineThrough: {
    textDecoration: 'line-through',
  },
  black: {
    color: '#000000 !important',
  },
  white: {
    color: '#FFFFFF !important',
  },
  red: {
    color: '#B33A3A !important',
  },
  primary: {
    color: '#522583',
  },
  left: {
    textAlign: 'left',
  },
  right: {
    textAlign: 'right',
  },
  center: {
    textAlign: 'center',
  },
  justify: {
    textAlign: 'justify',
  },
  size1: {
    fontSize: '1rem',
  },
  size2: {
    fontSize: '1.25rem',
  },
  unset: {},
});

export default Text;
